export function isOpenBot() {
  return ~window.location.href.indexOf('/bot/')
}
